// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const da: KnowledgePagesCopy = {
  knowledgePage: 'Videnside',
  knowledgePages: 'Vidensider',
  featureOffTitle: 'Vidensider er ikke slået til i dette arbejdsområde.',
  featureOffBody: 'Virksomhedskontekst og kilder findes stadig under Viden.',
  loadingPage: 'Indlæser side…',
  loadingSuggestion: 'Indlæser forslag…',
  cancel: 'Annuller',
  tryAgain: 'Prøv igen',
  everyoneIn: 'Alle i {company}',
  yourCompany: 'din virksomhed',
  revision: 'Revision {n}',
  openRevision: 'Åbn revision {n}',
  pageCount: 'one:side|other:sider',
  topicCount: 'one:emne|other:emner',
  sectionCount: 'one:afsnit|other:afsnit',
  lineCount: 'one:linje|other:linjer',
  documentCount: 'one:dokument|other:dokumenter',
  changeCount: 'one:ændring|other:ændringer',
  newPageCount: 'one:ny side|other:nye sider',
  changedPageCount: 'one:ændret side|other:ændrede sider',
  otherSectionCount: 'one:andet afsnit|other:andre afsnit',
  characterCount: 'one:tegn|other:tegn',
  diffStats: '{sections} ændret · {added} tilføjet · {removed} fjernet',
  diffMatchesBase: 'Den foreslåede tekst svarer til basisrevisionen.',
  diffIntroduction: 'Indledning',
  diffOtherUnchanged: '{sections} uændret.',
  timeJustNow: 'for et øjeblik siden',
  originImportedFrom: 'Importeret fra {path}',
  originImportedFromCommit: 'Importeret fra {path} @ {commit}',
  authorityApprovedInPoneva: 'Godkendt i Poneva',
  authorityImported: 'Importeret',
  authorityInRepository: '{canonicality} i repository',
  authorityVerified: 'bekræftet {date}',
  authorRepositoryImport: 'Import fra repository',
  authorSuggestedInChat: 'Foreslået i chatten',
  authorSuggestedInChatWith: 'Foreslået i chatten med {name}',
  authorSuggestedBy: 'Foreslået af {name}',
  authorSuggestedByApp: 'Foreslået af en forbundet app',
  authorSuggestedByColleague: 'Foreslået af en kollega',
  authorSuggestedByYou: 'Foreslået af dig',
  authorSuggestedOnBehalf: 'Foreslået af {app} på vegne af {name}',
  authorSuggestedByAppOnBehalf: 'Foreslået af en forbundet app på vegne af {name}',
  authorSuggestedAndApproved: 'Foreslået og godkendt af {name}',
  approverApprovedBy: 'godkendt af {name}',
  approverAppliedBy: 'anvendt af {name}',
  kindCreatePage: 'Ny side',
  kindUpdatePage: 'Foreslået opdatering',
  kindArchivePage: 'Arkivering',
  statusConflict: 'Konflikt · siden er ændret',
  statusPending: 'Afventer gennemgang',
  statusApproved: 'Godkendt',
  statusRejected: 'Afvist',
  statusWithdrawn: 'Trukket tilbage',
  statusSuperseded: 'Erstattet',
  errRevisionConflict: 'Denne side blev ændret, mens du gennemgik den.',
  errProposalChanged:
    'Dette forslag blev ændret, mens du gennemgik det. Gennemgå den nyeste version, før du beslutter dig.',
  errPublishRequired:
    'Kun udgivere i virksomheden kan godkende ændringer af viden eller importere sider.',
  errProposalLimit:
    'Din virksomhed har allerede 200 forslag, der venter på gennemgang. Gennemgå nogle af dem, før der foreslås flere.',
  errAuthorLimit:
    'Du har allerede 50 forslag, der venter på gennemgang. Vent, til nogle er afgjort, eller træk nogle tilbage, før du foreslår flere.',
  errImportProposalLimit:
    'Denne import ville tilføje flere ændrede sider til gennemgang, end der er plads til i din virksomheds gennemgangskø (højst 200). Afgør nogle forslag under Til gennemgang, og anvend importen igen.',
  errImportChanged:
    'Denne import er ikke den, du gennemgik. Åbn den igen, og gennemgå den, før du anvender den.',
  errImportItemNotFound: 'Dette dokument er ikke længere en del af importen.',
  errIdempotencyConflict:
    'Dette forslag er allerede sendt med et andet indhold. Genindlæs, og prøv igen.',
  errImportHashMismatch:
    'En fil i dette snapshot svarer ikke til sin registrerede kontrolsum. Opret et nyt snapshot, og prøv igen.',
  errImportAlreadyApplied: 'Denne import er allerede anvendt.',
  errImportDiscarded: 'Denne import blev kasseret. Vælg snapshotfilen igen.',
  errImportDuplicateItem:
    'Dette snapshot indeholder det samme dokument to gange. Opret snapshottet igen.',
  errInvalidImport:
    'Poneva kunne ikke acceptere dette snapshot. Opret et nyt med snapshotscriptet, og prøv igen.',
  errInvalidInput: 'Poneva kunne ikke acceptere dette input. Tjek felterne, og prøv igen.',
  errImportLimit:
    'For mange importer er klargjort, men ikke anvendt. Anvend eller kassér nogle, før du klargør en ny.',
  errPageTooLarge: 'En side er større end 256 KB. Del den op i mindre sider.',
  errTooManySections: 'En side har mere end 2.000 overskrifter. Del den op i mindre sider.',
  errPageLimit: 'Din virksomhed har nået grænsen på 2.000 vidensider.',
  errCollectionLimit: 'Din virksomhed har nået grænsen på 100 emner.',
  errProposalNotPending: 'Dette forslag er allerede afgjort. Den viste status er aktuel.',
  errRequesterRemoved:
    'Personen, der foreslog dette, er ikke længere i virksomheden, så det kan ikke godkendes.',
  errRevisionAlreadyCurrent: 'Den revision er allerede den aktuelle.',
  errPageArchived:
    'Denne side blev arkiveret, mens du gennemgik den. Gennemgå forslaget igen, før du beslutter dig.',
  errAlreadyArchived: 'Denne side er allerede arkiveret.',
  errProposalForbidden: 'Kun personen, der foreslog dette, kan trække det tilbage.',
  errUnavailable: 'Vidensider er ikke tilgængelige lige nu.',
  errTimeout: 'Poneva var for længe om at svare.',
  errItemTooLarge: '{path} er større end 256 KB. Del den op i mindre sider.',
  errItemTooManySections: '{path} har mere end 2.000 overskrifter. Del den op i mindre sider.',
  errItemHashMismatch:
    '{path} svarer ikke til sin registrerede kontrolsum. Opret et nyt snapshot, og prøv igen.',
  errNoLongerAvailable: 'Dette element er ikke længere tilgængeligt for dig.',
  errTooLargeToSend: 'Denne fil er for stor til at blive sendt.',
  cardChecking: 'Tjekker status…',
  cardNotAvailable: 'Ikke tilgængelig',
  cardStatusUnavailable: 'Status ikke tilgængelig',
  cardUnshowable: 'Denne foreslåede opdatering af viden kunne ikke vises.',
  cardEyebrow: 'Foreslået opdatering af viden',
  cardLabel: 'Foreslået opdatering af viden · {title}',
  cardMissing: 'Dette forslag er ikke længere tilgængeligt for dig.',
  cardUnknown: 'Vi kunne ikke tjekke, hvor dette forslag står. Åbn gennemgangen for at se status.',
  cardCheckAgain: 'Tjek igen',
  cardReview: 'Gennemgå opdatering',
  statusLineApproved: 'Godkendt forståelse',
  readyCount: 'one:klar til søgning|other:klar til søgning',
  preparingCount: 'one:forberedes|other:forberedes',
  attentionCount: 'one:kræver opmærksomhed|other:kræver opmærksomhed',
  topicsExplore: 'Udforsk et emne',
  topicsAllPages: 'Alle sider',
  topicsOpenPages: 'Åbn Sider',
  topicsEmpty:
    'Ingen godkendte sider endnu. Sider rummer virksomhedens forståelse i lang form med hele revisionshistorikken.',
  reviewsTitle: 'Foreslåede sideopdateringer',
  reviewsTitleMine: 'Dine foreslåede sideopdateringer',
  reviewsIntro:
    'Hvert forslag er en komplet kandidatrevision med begrundelse og dokumentation. Intet ændres, før du godkender præcis den revision.',
  reviewsIntroMine:
    'Dine forslag venter her, indtil en udgiver i virksomheden gennemgår dem. Indtil da forbliver siderne, som de er.',
  loadPagesFailed: 'Vi kunne ikke indlæse vidensider.',
  loadProposalsFailed: 'Vi kunne ikke indlæse foreslåede sideopdateringer.',
  loadMoreFailed: 'Vi kunne ikke indlæse flere sider.',
  otherPages: 'Andre sider',
  loadTopicFailed: 'Vi kunne ikke indlæse dette emne.',
  revisionShort: 'r{n}',
  updatedOn: 'Opdateret {date}',
  emptyTitle: 'Ingen vidensider endnu.',
  emptyBody:
    'Sider rummer din virksomheds godkendte forståelse i lang form — retning, beslutninger og arbejdsgange — med alle revisioner gemt. Importér fra et repository-snapshot, eller start en side i chatten; en udgiver godkender hver side, før den tæller som virksomhedens viden.',
  importFromSnapshot: 'Importér fra et repository-snapshot',
  startInChat: 'Start en side i chatten',
  startInChatPrompt:
    'Hjælp mig med at starte en videnside for vores virksomhed. Spørg, hvad den skal dække, og find ikke selv på indhold. Den forbliver et forslag, indtil en udgiver i virksomheden godkender den.',
  loadingPages: 'Indlæser vidensider…',
  filterLabel: 'Filtrer sider efter titel',
  filterPlaceholder: 'Filtrer sider',
  importButton: 'Importér',
  showingTopic: 'Viser {topic}',
  showAllTopics: 'Vis alle emner',
  loadingTopic: 'Indlæser dette emne…',
  noMatch: 'Ingen sider matcher “{filter}”.',
  topicNoPages: 'Ingen godkendte sider i dette emne endnu.',
  loading: 'Indlæser…',
  loadMore: 'Indlæs flere sider',
  metaApproved: 'godkendt {date}',
  metaRepositoryAuthoritative: 'repository er fortsat den gældende kilde',
  loadPageFailed: 'Vi kunne ikke indlæse denne side.',
  loadHistoryFailed: 'Vi kunne ikke indlæse revisionshistorikken.',
  outlineLabel: 'Sidens afsnit',
  outlineToggle: 'På denne side',
  loadingHistory: 'Indlæser revisionshistorik…',
  historyLabel: 'Revisionshistorik',
  historyIntro:
    'Alle godkendte revisioner gemmes. Gendannelse af en tidligere revision opretter et forslag til gennemgang; det sletter aldrig senere revisioner.',
  historyCurrent: 'Aktuel',
  historyViewing: 'Vises',
  historyView: 'Vis',
  historyViewAria: 'Vis revision {n}',
  restoreAria: 'Gendan som forslag: revision {n}',
  restoreCreating: 'Opretter forslag…',
  restore: 'Gendan som forslag',
  restoreUnconfirmed:
    'Vi kunne ikke bekræfte, at forslaget blev oprettet. Tjek Til gennemgang, før du prøver igen.',
  editTooLarge: 'Denne side er større end 256 KB. Del den op i mindre sider, før du foreslår den.',
  editConflict:
    'Denne side blev ændret, mens du redigerede. Kopiér din tekst, åbn den nyeste revision, og foreslå redigeringen igen.',
  editUnconfirmed:
    'Vi kunne ikke bekræfte, at dit forslag blev sendt. Tjek Til gennemgang, før du sender det igen.',
  editHeading: 'Foreslå en redigering',
  editIntro:
    'Du redigerer revision {n}. En udgiver i virksomheden gennemgår den præcise ændring, før den bliver til revision {next}; indtil da forbliver siden, som den er.',
  editOutdated:
    'En nyere revision blev godkendt, mens du redigerede. Kopiér din tekst, og start forfra fra den nyeste revision, så intet af det, den ændrede, går tabt.',
  editContentLabel: 'Sideindhold (Markdown)',
  editReasonLabel: 'Hvorfor denne ændring?',
  editReasonPlaceholder: 'Hvad er ændret, og hvor kommer det fra?',
  editSending: 'Sender…',
  editSend: 'Send til gennemgang',
  editDiscardConfirm: 'Kassér denne redigering? Intet af det, du har ændret, er blevet sendt.',
  editNoChanges: 'Ingen ændringer endnu.',
  editNeedsContent: 'En side skal have noget indhold.',
  exportFailed: 'Vi kunne ikke eksportere denne side. Prøv igen.',
  askPagePrompt: 'Spørgsmål om videnside “{title}” (revision {n}, {link}):',
  askPageSectionPrompt: 'Spørgsmål om videnside “{title}” § {section} (revision {n}, {link}):',
  pageMissingTitle: 'Denne side er ikke tilgængelig.',
  pageMissingBody:
    'Den kan være arkiveret, eller du har måske ikke længere adgang til denne virksomheds viden.',
  pageArchived: 'Arkiveret',
  viewingRevisionCurrent: 'Du ser revision {n}; den aktuelle revision er {current}.',
  viewingRevisionOld: 'Du ser revision {n}. Det er ikke den aktuelle revision.',
  openCurrent: 'Åbn aktuel',
  archivedBanner: 'Denne side er arkiveret. Den indgår ikke længere i svar; dens historik gemmes.',
  pageViewsLabel: 'Sidevisninger',
  tabRead: 'Læs',
  tabHistory: 'Historik',
  unknownSection: 'Det linkede afsnit er ikke en del af denne revision. Hele siden vises.',
  askAboutPage: 'Spørg om denne side',
  exporting: 'Eksporterer…',
  exportMarkdown: 'Eksportér Markdown',
  loadSuggestionFailed: 'Vi kunne ikke indlæse dette forslag.',
  evidenceSource: 'Kilde',
  evidenceFact: 'Virksomhedskontekst',
  evidenceResult: 'Gemt arbejde',
  evidenceUrl: 'Webside',
  evidenceDecision: 'Beslutning',
  evidenceReference: 'Henvisning',
  evidenceOpenPage: 'Åbn videnside',
  evidenceOpenSource: 'Åbn kilde',
  evidenceOpenFact: 'Åbn virksomhedskontekst',
  evidenceOpenResult: 'Åbn gemt arbejde',
  evidenceOpenUrl: 'Åbn webside',
  evidenceOpenDecision: 'Åbn beslutning',
  evidenceOpenReference: 'Åbn henvisning',
  evidenceDecisionNote: 'En registreret beslutning. Der er intet at åbne i Poneva.',
  evidenceFactGone: 'Denne virksomhedskontekst er ikke længere gemt.',
  evidencePageNoRevision: 'Denne side har ingen godkendt revision at åbne.',
  evidencePrivateExcerpt: 'Privat dokumentation — kun uddraget ovenfor blev delt.',
  evidencePrivate: 'Privat dokumentation — indholdet blev ikke delt med dig.',
  evidenceHeading: 'Dokumentation',
  evidenceNone: 'Der er ikke vedhæftet dokumentation. Vurder begrundelsen ovenfor for sig selv.',
  changeAdded: 'Tilføjet',
  changeRemoved: 'Fjernet',
  changeChanged: 'Ændret',
  changeUnchanged: 'Uændret',
  moreLineCount: 'one:linje mere|other:linjer mere',
  moreUnchangedLineCount: 'one:uændret linje mere|other:uændrede linjer mere',
  unchangedLineCount: 'one:uændret linje|other:uændrede linjer',
  skipAdded: '{lines} — vises i den komplette revision',
  skipRemoved: '{lines} fjernet',
  cutUnchanged: '{lines} vises ikke',
  cutChanged: '{lines} vises ikke, {changes}. Tjek dem i den komplette revision.',
  cutAddedRemoved: '{added} tilføjet og {removed} fjernet',
  cutAdded: '{added} tilføjet',
  cutRemoved: '{removed} fjernet',
  lineAddedSr: 'Tilføjet:',
  lineRemovedSr: 'Fjernet:',
  noLinesAdded: 'Et nyt afsnit. Teksten står i den komplette revision nedenfor.',
  noLinesRemoved: 'Dette afsnit ville blive fjernet fra siden.',
  noLinesChanged: 'Dette afsnit ændres. Teksten står i den komplette revision nedenfor.',
  diffHeading: 'Ændringer',
  outcomeArchived: 'Arkiveret.',
  outcomeArchivedBody:
    '{title} indgår ikke længere i svar og er fjernet fra sidelisten. Dens revisioner, dette forslag og beslutningen forbliver i sidens historik.',
  openArchivedPage: 'Åbn arkiveret side',
  outcomeApproved: 'Godkendt.',
  outcomeApprovedRevision: 'Revision {n} er nu den godkendte version af {title}.',
  outcomeApprovedPlain: 'Dette forslag blev godkendt.',
  outcomeRestored: 'Siden er tilbage på sidelisten og indgår i svar igen.',
  outcomeKept: 'Forslaget, beslutningen og alle tidligere revisioner forbliver i sidens historik.',
  openPage: 'Åbn side',
  outcomeDismissed: 'Afvist.',
  outcomeWithdrawn: 'Trukket tilbage.',
  outcomeSuperseded: 'Erstattet.',
  outcomeSupersededBody:
    'En nyere revision, et nyere forslag eller en nyere import fra repository gjorde dette forslag forældet. Det ændrede ikke noget i sig selv.',
  outcomeUnchanged: 'Siden forbliver, som den er.',
  approveNewPage: 'Godkend ny side',
  approveArchive: 'Godkend arkivering',
  approveRestoreRevision: 'Gendan og godkend revision {n}',
  approveRevision: 'Godkend revision {n}',
  approveArchiveNote: 'Godkendelse arkiverer denne side for alle i {company}.',
  approvePublishNote: 'Godkendelse udgiver denne revision for alle i {company}.',
  approvePublishEvidenceNote:
    'Godkendelse udgiver denne revision og de viste uddrag af dokumentationen ovenfor for alle i {company}.',
  archivedTitle: 'Denne side er arkiveret.',
  alreadyArchivedBody: 'En godkendelse ville ikke ændre noget, så dette forslag kan kun afvises.',
  archivedRestoreBody:
    'Godkendelse gendanner den: Siden vender tilbage til sidelisten, søgningen og svarene med denne revision.',
  staleRevisionAction: 'Sammenlign med den nyeste version',
  staleProposalTitle: 'Dette forslag blev ændret, mens du gennemgik det.',
  staleProposalAction: 'Gennemgå den nyeste version',
  staleArchivedTitle:
    'Denne side blev arkiveret, mens du gennemgik den. Hvis du godkender dette forslag, bliver den hentet tilbage.',
  staleArchivedAction: 'Gennemgå igen',
  suggestionMissingTitle: 'Dette forslag er ikke tilgængeligt.',
  suggestionMissingBody:
    'Det kan være trukket tilbage, eller det tilhører en anden og er ikke sendt til gennemgang i virksomheden.',
  decideUnconfirmed:
    'Vi kunne ikke bekræfte din beslutning. Den viste status er den nyeste fra Poneva; tjek den, før du prøver igen.',
  decideFailed: 'Vi kunne ikke gemme din beslutning.',
  discussPrompt:
    'Hjælp mig med at forbedre den foreslåede opdatering af viden til “{title}” ({link}).',
  conflictBody:
    'Dette forslag blev skrevet ud fra revision {base}; den aktuelle revision er {current}. En godkendelse ville overskrive den ændring, så forslaget kan ikke godkendes, som det er.',
  conflictBodyPlain:
    'Dette forslag blev skrevet ud fra en tidligere revision, så det kan ikke godkendes, som det er.',
  openLatest: 'Åbn den nyeste version',
  reworkInChat: 'Omarbejd i chatten',
  factReason: 'Begrundelse',
  factNoReason: 'Der blev ikke givet nogen begrundelse.',
  factAudience: 'Målgruppe',
  factRevision: 'Revision',
  revisionNew: 'En ny side, revision 1',
  revisionArchiveAfter: 'Arkivér efter revision {n}',
  revisionWrittenAgainst: 'Skrevet ud fra revision {base}; den aktuelle revision er {current}',
  revisionCurrentToProposed: 'Aktuel revision {base} → foreslået revision {next}',
  revisionProposed: 'Foreslået revision {next}',
  proposedPage: 'Foreslået side',
  archivingHeading: 'Hvad arkivering gør',
  archivingBody:
    'Siden indgår ikke længere i svar og fjernes fra sidelisten. Dens revisioner og denne beslutning gemmes.',
  noComparison: 'Der er ingen sammenligning af afsnit for dette forslag.',
  showComplete: 'Vis komplet revision',
  approving: 'Godkender…',
  dismissing: 'Afviser…',
  dismiss: 'Afvis',
  withdrawing: 'Trækker tilbage…',
  withdraw: 'Træk tilbage',
  editInChat: 'Redigér i chatten',
  waitingForPublisher: 'Venter på, at en udgiver i virksomheden gennemgår det.',
  snapshotTooLarge: 'Dette snapshot er større end 8 MB. Opret det med færre dokumenter.',
  snapshotNotSnapshot:
    'Denne fil er ikke et vidensnapshot. Vælg den JSON-fil, som snapshotscriptet skrev.',
  snapshotEmpty: 'Dette snapshot indeholder ingen dokumenter.',
  readDocumentFailed: 'Vi kunne ikke læse dette dokument. Prøv igen.',
  readingDocument: 'Læser dokumentet…',
  hideText: 'Skjul tekst',
  readText: 'Læs tekst',
  textOf: 'Teksten i {title}',
  gitSnapshot: 'Git-snapshot {commit}',
  repositorySnapshot: 'Repository-snapshot',
  importNewHeading: '{pages} · godkendes, når du anvender importen',
  importNewNote:
    'Hver side udgives som en godkendt side for alle i {company} uden yderligere gennemgang. Læs hver enkelt, før du anvender importen.',
  importChangedHeading: '{pages} · sendes til gennemgang',
  importChangedNote:
    'Hver bliver en foreslået opdatering. Siden ændres først, når en udgiver godkender den under Til gennemgang, som viser, hvad der er ændret.',
  unchangedDocumentCount: 'one:uændret dokument|other:uændrede dokumenter',
  unchangedNote: 'Disse svarer allerede til deres godkendte sider. Der skrives intet for dem.',
  stagedHeading: 'Klargjort, men ikke anvendt',
  excludedSummary: '{documents} udeladt af dette snapshot',
  countsLine: '{newPages} · {changedPages} til gennemgang · {unchanged} uændret',
  importAlreadyDiscarded: 'Denne import er allerede kasseret.',
  confirmLabel: 'Bekræft import',
  unchangedKeepCount:
    'one:uændret dokument beholder sin side|other:uændrede dokumenter beholder deres sider',
  confirmBody:
    'Vil du anvende denne import for alle i {company}? {newPages} godkendes som revision 1, {changedPages} venter på gennemgang, og {unchanged}. Tidligere importforslag for disse sider trækkes tilbage.',
  applying: 'Anvender…',
  applyImport: 'Anvend import',
  chooseAnother: 'Vælg en anden fil',
  allCurrent: 'Alt i dette snapshot er allerede opdateret.',
  importApplied: 'Importen er anvendt.',
  appliedSummary: '{pages} oprettet · {changes} venter på gennemgang · {unchanged} uændret.',
  appliedIndexing:
    'Nye sider bliver søgbare i chatten, når indekseringen er færdig. Forberedelse af kilder viser fremskridtet.',
  openPages: 'Åbn sider',
  reviewChanges: 'Gennemgå {changes}',
  checkIndexing: 'Tjek indekseringens fremskridt',
  sendSnapshotFailed: 'Vi kunne ikke sende dette snapshot. Prøv igen.',
  openStagedFailed: 'Vi kunne ikke åbne denne klargjorte import.',
  applyUnconfirmed:
    'Vi kunne ikke bekræfte, om importen blev anvendt. Tjek Sider, før du prøver igen.',
  applyFailed: 'Vi kunne ikke anvende denne import.',
  importHeading: 'Importér sider fra repository',
  backToPages: 'Tilbage til sider',
  importLead:
    'Opret et snapshot med {command}, og vælg derefter filen. Du ser hvert dokument, og hvad det ville ændre, før noget gemmes.',
  snapshotFileLabel: 'Vidensnapshotfil',
  readingSnapshot: 'Læser snapshot…',
  openingStaged: 'Åbner klargjort import…',
  chooseSnapshot: 'Vælg snapshotfil',
  factOrigin: 'Oprindelse',
  factContents: 'Indhold',
  importOnlyListed: 'Kun de dokumenter, der er angivet her, importeres.',
  importRepositoryAuthoritative:
    'Repository forbliver den gældende kilde; ændrede dokumenter bliver til forslag til gennemgang.',
  overviewReviewChanges: 'Gennemgå ændringer',
  overviewConnectAgents: 'Forbind eksterne agenter',
  overviewEyebrow: 'En fælles forståelse',
  overviewTitle: '{company} i kontekst.',
  overviewLeadFallback:
    'Din virksomheds viden begynder med den kontekst, du deler. Opbyg sammen en forståelse af jeres forretning.',
  overviewBody:
    'Virksomhedskontekst og kildemateriale giver Poneva et udgangspunkt — ikke alt, hvad der er at vide om {company}. Bliv ved med at opbygge denne forståelse, efterhånden som jeres forretning udvikler sig.',
  overviewAskPrompt: 'Hvad ved du om vores virksomhed, og hvad ville være nyttigt at tilføje?',
  overviewAsk: 'Spørg om {company}',
  overviewAddSources: 'Tilføj kilder',
  contextEyebrow: 'Hvad giver svarene kontekst',
  contextTitle: 'Forretningen bag spørgsmålet.',
  contextBody:
    'Webkilder forklarer den offentlige side af forretningen. Virksomhedsnoter tilføjer jeres terminologi, prioriteter og måde at arbejde på.',
  contextPrompt:
    'Hjælp mig med at præcisere de prioriteter og arbejdspræferencer i virksomheden, som vi bør huske.',
  contextAction: 'Opbyg vores forståelse',
  learnEyebrow: 'Plads til at lære',
  learnTitle: 'Start med det, der betyder mest nu.',
  learnBody:
    'Hent kildemateriale ind, eller præcisér, hvordan din virksomhed arbejder. Poneva kan foreslå varige ændringer, som du gennemgår.',
  learnPrompt:
    'Hvilke vigtige oplysninger mangler der ud fra vores eksisterende virksomhedsviden til det arbejde, vi vil udføre?',
  learnAction: 'Drøft, hvad der ville være nyttigt',
  canvasEmptyTitle: 'Lidt kontekst rækker langt.',
  canvasEmptyBody:
    'Din virksomhedsprofil er udgangspunktet. Tilføj kildemateriale og gennemgåede noter for at hjælpe Poneva med at forstå jeres arbejde.',
  pageEyebrow: 'Arbejdsområde for {company}',
  pageTitle: 'Virksomhedens viden',
  pageDescription: 'Kilderne og forståelsen bag Ponevas arbejde.',
  tabOverview: 'Oversigt',
  tabPages: 'Sider',
  tabSources: 'Kilder',
  tabReview: 'Til gennemgang',
  proposalApproved: 'Godkendt virksomhedskontekst',
  proposalDismissed: 'Afvist forslag',
  proposalRemoval: 'Foreslået fjernelse',
  proposalCorrection: 'Foreslået rettelse',
  proposalContext: 'Foreslået virksomhedskontekst',
  proposalCurrent: 'Nuværende forståelse',
  proposalFactGone:
    'Den gemte oplysning er ikke længere tilgængelig. Opdater virksomhedsviden, før du gennemgår denne fjernelse.',
  proposalReviewFallback: 'Gennemgå den foreslåede virksomhedskontekst.',
  proposalNotSaved: 'Ikke gemt endnu. De oprindelige kilder er uændrede.',
  proposalWaiting: 'Venter på gennemgang · en udgiver beslutter i sin Indbakke',
  proposalSaving: 'Gemmer…',
  proposalApproveRemoval: 'Godkend fjernelse',
  proposalApproveClarification: 'Godkend præcisering',
  factLabel: 'Virksomhedsoplysning',
  factEyebrow: 'Oplysning · Alle i {company}',
  factSuggestCorrection: 'Foreslå en rettelse',
  factAskPrompt:
    'Hjælp mig med at forstå eller præcisere denne gemte virksomhedskontekst: “{content}”',
  factAsk: 'Spørg om det',
  companyContextHeading: 'Virksomhedskontekst',
  companyContextPrompt:
    'Jeg vil gerne præcisere vores virksomhedsviden. Hjælp mig med at gennemgå, hvad vi ved, og foreslå en opdatering.',
  companyContextEmpty:
    'Ingen godkendte noter endnu. Start en samtale om din virksomhed, eller tilføj kildemateriale nedenfor.',
  refineInChat: 'Finpuds i chatten',
  reviewPanelLabel: 'Ændringer af viden til gennemgang',
  suggestedUpdatesHeading: 'Foreslåede opdateringer',
  suggestedUpdatesIntro:
    'Forslag fra dine samtaler. Du bestemmer, hvad der bliver en varig del af din virksomheds viden.',
  reviewEmptyTitle: 'Intet venter på din gennemgang.',
  reviewEmptyBody:
    'Når Poneva foreslår en ændring af din virksomhedsviden, finder du den her. Varige ændringer kræver altid din godkendelse.',
  reviewEmptyPrompt:
    'Hjælp mig med at gennemgå vores virksomhedsviden, og foreslå, hvad det ville være nyttigt at præcisere som det næste.',
  inclusionPendingApproval: 'Ændring af medtagelse i viden er sendt til godkendelse.',
  sourcesFileIncluded: 'Filen er medtaget i vidensøgningen for sin nuværende målgruppe.',
  sourcesAddFailed: 'Kilden kunne ikke tilføjes.',
  sourcesHeading: 'Materialet bag svarene.',
  sourcesIntro:
    'Poneva søger i hele kildematerialet, ikke kun i oversigten. Behold originalerne, se, hvad der er klar, og vælg, hvad der skal præge dine svar.',
  addSourceHeading: 'Tilføj materiale fra din virksomhed',
  addSourceIntro:
    'Uploadede kilder forbliver private i dit Bibliotek og præger dine egne svar. Vælg Del, når du er klar til at gøre dem tilgængelige for kolleger.',
  uploadSource: 'Upload en kilde',
  addSourcePrompt:
    'Hjælp mig med at tilføje en virksomhedserklæring som en delt intern kilde. Spørg, hvad jeg vil registrere, og find ikke selv på indhold. Varige ændringer af virksomhedens forståelse kræver stadig min godkendelse.',
  addThroughChat: 'Tilføj via chatten',
  addingSource: 'Tilføjer…',
  addToKnowledge: 'Føj til viden',
  uploadFormats: 'TXT, Markdown, CSV og JSON · Op til 5 MB pr. fil',
  sourceExcluded: 'Udeladt fra svar',
  sourcePreparationFailed: 'Forberedelsen mislykkedes',
  sourcePreparing: 'Forberedes til søgning',
  sourceWaiting: 'Venter på forberedelse',
  sourceReadinessUnknown: 'Status for klarhed er ikke tilgængelig',
  sourceRetryQueued: 'Forberedelsen er sat i kø. Status opdateres, når den er færdig.',
  sourceIncludedNotice: 'Kilden er medtaget. Poneva forbereder den til søgning.',
  sourceExcludedNotice: 'Udeladt fra svar. Den oprindelige kilde bevares.',
  sourceUpdateFailed: 'Kilden kunne ikke opdateres.',
  sourceOriginalMaterial: 'Oprindeligt kildemateriale',
  sourceDiscuss: 'Drøft i chatten',
  sourceDiscussPrompt: 'Hjælp mig med at forstå eller præcisere “{title}”.',
  sourceExclude: 'Udelad fra svar',
  sourceInclude: 'Medtag i svar',
  sourcesLoadFailed: 'Vi kunne ikke indlæse dine kilder.',
  sourceLibraryLabel: 'Virksomhedens kildebibliotek',
  sourceListCaption: 'Oprindelige kilder · medtagne og udeladte',
  sourceSearchLabel: 'Søg i virksomhedens kilder',
  sourceSearchPlaceholder: 'Søg i dine kilder…',
  sourcesFinding: 'Finder dine kilder…',
  sourcePagesLabel: 'Kildesider',
  sourceRange: '{from}–{to} af {count}',
  sourceCount: 'one:kilde|other:kilder',
  sourcePrevious: 'Forrige',
  sourceNext: 'Næste',
  sourceNoMatchTitle: 'Ingen matchende kilder.',
  sourceNoMatchBody: 'Prøv en anden formulering eller et andet kildenavn.',
  sourceEmptyTitle: 'Giv dine spørgsmål et stærkere udgangspunkt.',
  sourceEmptyBody:
    'Tilføj virksomhedsdokumenter, produktdata eller arbejdsnoter. Poneva kan bruge hele kildematerialet i samtaler og Skills.',
  indexCheckFailed: 'Vi kunne ikke tjekke forberedelsen af kilder.',
  indexRetryQueued:
    'Mislykkede videnposter er sat i kø til forberedelse. Dit kildemateriale er uændret.',
  indexQueueFailed: 'Vi kunne ikke sætte forberedelsen i kø. Prøv igen.',
  indexPreparing: 'Forbereder ny viden til dine samtaler…',
  indexAttention: 'Noget viden kræver opmærksomhed.',
  queuing: 'Sætter i kø…',
  retryPreparation: 'Prøv forberedelsen igen',
  sourceKindStatement: 'Virksomhedserklæring',
  sourceKindWebsite: 'Websted',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:svar|other:svar',
  factUsedThisWeek: 'Brugt i {answers} i denne uge',
  factLastUsed: 'sidst brugt {when}',
  factToday: 'i dag',
  factYesterday: 'i går',
  factImpact: 'Ændringen påvirker en virksomhedsoplysning, der er brugt i {answers} i denne uge.',
  factCorrectionAbout: 'Om denne virksomhedsoplysning: “{content}” ({link})',
  factCorrectionOutdated: 'Dette er forældet:',
  sourceCanvasRecorded: 'Registreret kildemateriale',
  sourceCanvasNotIncluded:
    'Ikke inkluderet i virksomhedens viden. Originalen gemmes som reference og kan stadig bruges i en bestemt samtale.',
  sourceCanvasOpenOriginal: 'Åbn oprindelig kilde',
  sourceCanvasUnavailable: 'Kildens indhold er ikke tilgængeligt.',
  sourceCanvasDiscussPrompt: 'Hjælp mig med at forstå eller præcisere “{title}”.',
  sourceCanvasDiscuss: 'Drøft denne kilde',
  sourceCanvasCorrectionNote:
    'En rettelse bliver til foreslået virksomhedskontekst. Den registrerede kilde forbliver uændret.',
  contextCanvasEyebrow: 'Tilgængelig virksomhedskontekst',
  contextCanvasTitle: 'Viden bag denne samtale.',
  contextCanvasBody:
    'Godkendt forståelse og det kildemateriale, din virksomhed har tilføjet. Tilgængelig i chatten og i Skills.',
  contextCanvasOpen: 'Åbn Viden',
};

export default da;
